<template>
  <div id="app">
    <router-view />
  </div>
</template>
<script>
  import {mobileCheck} from "@/utils/mobile_check.js";
  export default {
    mounted(){
      if(location.href.includes("bnb-stage-coach-deep.carrotglobal.com")){
        if(mobileCheck(navigator.userAgent || navigator.vendor || window.opera)){
          let varUA = navigator.userAgent.toLowerCase()
          if (varUA.match('android') != null) { 
            window.location.href= "market://details?id=com.carrotenglish.ctest";
          } else if (varUA.indexOf("iphone")>-1||varUA.indexOf("ipad")>-1||varUA.indexOf("ipod")>-1) { 
            window.location.href= "https://apps.apple.com/us/app/spac/id1225076497"; 
          } else {
            alert("모바일에서만 제공됩니다");
            window.close();
          }
        }else{
          alert("모바일에서만 제공됩니다");
          window.close();
        }
      }
    }
  }
</script>
<style lang="scss"> 
    @import "src/assets/style/reset.scss";
    @import "src/assets/style/common.scss";
    @import "src/assets/style/style.scss";
</style>
